import { Progress } from '../../../components/progress';
import { Button } from '../../../components/button';
import { Spinner } from '../../../components/spinner';
import { type BaseUploadingFileItem, formatFileSize } from './file';

type UploadingFileItemProps = {
  file: BaseUploadingFileItem;
  onCancel?: () => void;
};

export function UploadingFileItem({ file, onCancel }: UploadingFileItemProps) {
  return (
    <div className="rounded-md p-4 flex flex-col gap-4 border border-border">
      <div className="flex justify-between">
        <div className="flex gap-4">
          <div className="w-8 h-8 flex items-center justify-center bg-muted rounded-[4px] border border-border">
            <Spinner className="size-8" />
          </div>
          <div className="flex flex-col gap-1">
            <div className="text-sm">{file.fileName}</div>
            <div className="text-sm text-muted-foreground">
              {formatFileSize((file.fileSize * file.progress) / 100)}/{' '}
              {formatFileSize(file.fileSize)}
            </div>
          </div>
        </div>
        <Button variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </div>
      <Progress className="h-[8px]" value={file.progress} />
    </div>
  );
}
